import apiClient from '/api.js';
import router from '/src/router'
import { defineStore } from 'pinia';


export const useAuthStore = defineStore('auth', {
  state: () => ({
    rolesByIndex: JSON.parse(localStorage.getItem('rolesByIndex') || '[]'),
    userID:       localStorage.getItem('userID')      || '',
    firstName:    localStorage.getItem('firstName')   || '',
    last_name:    localStorage.getItem('last_name')   || '',
    calendarType: localStorage.getItem('calendarType') || 'table',
    calendarShowMore: JSON.parse(localStorage.getItem('calendarShowMore') ?? 'true'),



  }),
  getters: {
    isLoggedIn: (state) => !!state.userID,

    availableIndexes: state => state.rolesByIndex.map(r => r.index),
    // ===> autodetekce indexu z prvního záznamu
    clubIndex:      state => state.rolesByIndex[0]?.index || '',  // index ve svém oddíle
    clubPermissions: state => state.rolesByIndex[0]?.permissions || [], // pravomoce ve svém oddíle

/**
     * Check permission by either clubId (number) or index prefix (string)
     * @param {string} roleName - name of the permission to check
     * @param {number|string} filter - clubId if number, prefix if string
     * např. authStore.isOrganizer('RCZ') nebo authStore.isClubManager(2) nebo authStore.isOrganizer() když chci projet všechny práva
     */
    hasPermissionFor: state => (permName, filter) => {
      const clubId = typeof filter === 'number' ? filter : null;
      const prefix = typeof filter === 'string' ? filter : null;
      return state.rolesByIndex.some(entry => {
        const matchClub = clubId != null ? entry.club === clubId : true;
        const matchPrefix = prefix != null ? entry.index.startsWith(prefix) : true;
        return matchClub && matchPrefix && entry.permissions.includes(permName);
      });
    },

    isOrganizer: state => filter => state.hasPermissionFor('organizer', filter),
    isManager:   state => filter => state.hasPermissionFor('manager', filter),
    isClubManager: state => filter => state.hasPermissionFor('club_manager', filter),
  },


  actions: {

    // aktualizace rolí uživatelů
    updateRoles(newRoles) {
      this.rolesByIndex = newRoles;
      localStorage.setItem('rolesByIndex', JSON.stringify(newRoles));
    },

    // Uložení typu kalendáře
    toggleCalendar() {
      this.calendarType = this.calendarType === 'table' ? 'graphical' : 'table';
      localStorage.setItem('calendarType', this.calendarType);
    },

    // Uložení nastavení rozevírání (show more) v table kalendáři
    toggleCalendarShowMore() {
      this.calendarShowMore = !this.calendarShowMore;
      localStorage.setItem('calendarShowMore', JSON.stringify(this.calendarShowMore));
    },


    async login(email, password) {
      try {
        const resp = await apiClient.post(
          '/login/',
          { email, password },
          { withCredentials: true }
        );
        const {
          roles,       // očekáváme pole objektů { index, roles }
          userID,
          first_name,
          last_name
        } = resp.data;

        this.userID = userID;
        this.firstName = first_name;
        this.last_name = last_name;
        this.updateRoles(roles);

      
        localStorage.setItem('userID', this.userID);
        localStorage.setItem('firstName', this.firstName);
        localStorage.setItem('last_name', this.last_name);

      } catch (error) {
        console.error('Chyba při přihlášení', error);
        
        // Zde extrahujeme chybovou zprávu
        let errorMessage = "Došlo k neznámé chybě při přihlašování.";
        if (error.response) {
          // Server vrátil chybovou odpověď
          if (error.response.data && error.response.data.detail) {
            errorMessage = error.response.data.detail;
          } else if (error.response.status === 401) {
            errorMessage = "Neplatné přihlašovací údaje.";
          }
        } else if (error.request) {
          // Požadavek byl odeslán, ale neobdrželi jsme žádnou odpověď
          errorMessage = "Server neodpovídá. Zkuste to prosím později.";
        }
        throw new Error(errorMessage);
      }
    },

    
    async logout() {

      try {
        await apiClient.post('/logout/'); // response smaže cookie
      } catch (e) {
        console.warn('Logout failed (možná už je smazaná cookie)');
      }

      this.userID = '';
      this.rolesByIndex = [];
      this.userClub = ''; // TOD časem smazat 6/2025
      this.firstName = '';
      this.last_name = '';
      localStorage.removeItem('authToken');
      localStorage.removeItem('userID');
      localStorage.removeItem('roles'); // TODO časem smazat 6/2025
      localStorage.removeItem('index');  // TODO časem smazat 6/2025
      localStorage.removeItem('surname');  // TOD časem smazat 6/2025
      localStorage.removeItem('rolesByIndex');      
      localStorage.removeItem('userClub'); // TOD časem smazat 6/2025
      localStorage.removeItem('firstName');
      localStorage.removeItem('last_name');

      await router.replace('/');
      router.go(0);
      },
  },
});
